import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const UserRateOverride = z.object({
    rate: z.number().transform((value) => value / 100),
    userCode: z.string(),
});

export type UserRateOverride = z.infer<typeof UserRateOverride>;
